
class FlickityCarouselBase extends HTMLElement {
  constructor() {
    super();
    this.flickity = null;
    this.breakpoint = 990;
    this._mql = null;
    this._ro = null;
    this._currentMode = null;
    this._handleBreakpointChange = this._handleBreakpointChange.bind(this);
    this._handleResize = this._handleResize.bind(this);
  }

  connectedCallback() {
    if (!this.shouldInit()) return;
    if (typeof Flickity === "undefined") {
      window.addEventListener("load", () => this._start(), { once: true });
    } else {
      this._start();
    }
  }

  disconnectedCallback() {
    this._mql?.removeEventListener("change", this._handleBreakpointChange);
    this._ro?.disconnect();
    this._ro = null;
    this._destroy();
  }

  // ---- Hooks (override in subclasses) ----

  shouldInit() {
    return true;
  }

  getMode() {
    return window.matchMedia(`(min-width: ${this.breakpoint}px)`).matches
      ? "desktop"
      : "mobile";
  }

  shouldRunAtMode(_mode) {
    return true;
  }

  getFlickityOptions(_mode) {
    return {
      cellAlign: "center",
      contain: true,
      pageDots: true,
      prevNextButtons: false,
    };
  }

  observeResize() {
    return false;
  }

  onResize(_mode) {}
  beforeInit(_mode) {}
  afterInit(_mode) {}
  beforeDestroy() {}
  afterDestroy() {}

  // ---- Internals ----

  _start() {
    this._mql = window.matchMedia(`(min-width: ${this.breakpoint}px)`);
    this._mql.addEventListener("change", this._handleBreakpointChange);

    if (this.observeResize()) {
      this._ro = new ResizeObserver(this._handleResize);
      this._ro.observe(this);
    }

    const mode = this.getMode();
    if (this.shouldRunAtMode(mode)) this._init(mode);
  }

  _init(mode) {
    if (typeof Flickity === "undefined") return;
    if (this.flickity) return;
    this._currentMode = mode;
    this.beforeInit(mode);
    this.flickity = new Flickity(this, this.getFlickityOptions(mode));
    this.afterInit(mode);
  }

  _destroy() {
    if (!this.flickity) return;
    this.beforeDestroy();
    this.flickity.destroy();
    this.flickity = null;
    this._currentMode = null;
    this.afterDestroy();
  }

  _handleBreakpointChange() {
    const mode = this.getMode();
    this._destroy();
    if (this.shouldRunAtMode(mode)) this._init(mode);
  }

  _handleResize() {
    if (!this._currentMode) return;
    this.onResize(this._currentMode);
    this.flickity?.resize();
  }
}

window.FlickityCarouselBase = FlickityCarouselBase;


if (!customElements.get("flickity-carousel")) {
  customElements.define(
    "flickity-carousel",
    class FlickityCarousel extends FlickityCarouselBase {
      shouldRunAtMode(mode) {
        const want = (this.dataset.runAtMode || "both").toLowerCase();
        if (want === "both") return true;
        return want === mode;
      }

      getFlickityOptions(mode) {
        const base = this._parseOptions(this.dataset.options);
        const modeOverrides =
          mode === "mobile"
            ? this._parseOptions(this.dataset.optionsMobile)
            : this._parseOptions(this.dataset.optionsDesktop);
        return {
          cellAlign: "left",
          contain: true,
          pageDots: true,
          prevNextButtons: false,
          ...base,
          ...modeOverrides,
        };
      }

      _parseOptions(raw) {
        if (!raw) return {};
        try {
          return JSON.parse(raw);
        } catch (_) {
          return {};
        }
      }
    },
  );
}
